export default __webpack_public_path__ + "static/media/6、首页气泡果汁.f02c8175.jpg";